import {useEffect} from 'react';
import {useInRouterContext, useLocation} from 'react-router-dom';

function ScrollToTopContent() {
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Avoid calling useLocation when this component is rendered outside a router.
export default function ScrollToTop() {
  const inRouter = useInRouterContext();

  return inRouter ? <ScrollToTopContent /> : null;
}